// Metadados de exibicao das grandezas da BLUEBOX (thing type_id 3, sempre
// associada a uma EBA). As chaves batem com os ihmnames/codigos curtos que
// o dispositivo publica no MQTT/DynamoDB (ver doc MQTT Higra / backend
// BLUEBOX_SUGGESTED_VARIABLES). A tela le esses campos direto do thingsValue.
//
// So as principais ficam nos cards do diagrama e nos KPIs do Resumo; o
// restante das variaveis o operador adiciona como favorito pela tela de
// variaveis (fluxo generico).

// As regras especiais valem exclusivamente para as seis maquinas oficiais,
// Bluebox00001 ate Bluebox00006. O tipo nao e usado porque outras maquinas,
// como smartpump, podem compartilhar o mesmo cadastro de tipo.
export const isBlueboxThings = (things) => {
  const item = things && things[0];
  const name = String((item && (item.thing || item.name)) || '').trim();
  return /^bluebox0000[1-6]$/i.test(name);
};

// transform: converte o valor cru pra unidade exibida (ex.: W -> kW).
export const BLUEBOX_HEADLINE_CARDS = [
  { key: 'W', label: 'Potência ativa', unit: 'kW', transform: (v) => v / 1000 },
  { key: 'Iavg', label: 'Corrente média', unit: 'A' },
  { key: 'VLavg', label: 'Tensão de linha média', unit: 'V' },
  { key: 'FP', label: 'Fator de potência', unit: '', digits: 3 },
  { key: 'Rev', label: 'Rotação', unit: 'rpm', digits: 0 },
  { key: 'Press', label: 'Pressão', unit: 'bar' },
];

// Formata um valor cru do thingsValue conforme a definicao da variavel.
// Retorna '-' quando ausente; senao numero PT-BR + unidade.
export const formatBlueboxValue = (raw, def = {}) => {
  if (raw === undefined || raw === null || raw === '') return '-';
  const n = Number(raw);
  if (!Number.isFinite(n)) return String(raw);
  const val = def.transform ? def.transform(n) : n;
  const digits = def.digits != null ? def.digits : 2;
  const formatted = val.toLocaleString('pt-BR', {
    maximumFractionDigits: digits,
  });
  return def.unit ? `${formatted} ${def.unit}` : formatted;
};

// --- Mapas de bits de alarme/trip (doc MQTT, aba "mapa de bits") ---
// Alr1 e Trp1 usam ALR1_TRP1_BITS; Alr2 e Trp2 usam ALR2_TRP2_BITS. O
// indice do array = numero do bit. null = "nao utilizado".
export const ALR1_TRP1_BITS = [
  'Temperatura do motor fase R',
  'Temperatura do motor fase S',
  'Temperatura do motor fase T',
  'Temperatura do mancal radial',
  'Temperatura do mancal axial',
  'Temperatura CPU',
  'Tensão dos sensores',
  'Tensão alimentação',
  'Tensão da CPU',
  'Pressão',
  'Rotação',
  'Aceleração X RMS',
  'Aceleração Y RMS',
  'Aceleração Z RMS',
  'Velocidade X RMS',
  'Velocidade Y RMS',
  'Velocidade Z RMS',
  'Inclinação',
  'Horímetro',
  'Estado da bateria',
  'Nível 1',
  'Nível 2',
  'Sinal/ruído PLC (supervisor)',
  'Tensão de fase média',
  'Tensão da fase R',
  'Tensão da fase S',
  'Tensão da fase T',
  'Corrente média',
  'Corrente na fase R',
  'Corrente na fase S',
  'Corrente na fase T',
  'Tensão de linha média',
];

export const ALR2_TRP2_BITS = [
  'Tensão da linha RS',
  'Tensão da linha ST',
  'Tensão da linha TR',
  'Fator potência total',
  'Fator potência da fase R',
  'Fator potência da fase S',
  'Fator potência da fase T',
  'Potência ativa total',
  'Potência ativa da fase R',
  'Potência ativa da fase S',
  'Potência ativa da fase T',
  'Potência reativa total',
  'Potência aparente total',
  'Frequência instantânea',
  'THD Tensão RN | RS',
  'THD Tensão SN | ST',
  'THD Tensão TN | TR',
  'THD Corrente R',
  'THD Corrente S',
  'THD Corrente T',
  'Energia ativa direta',
  'Energia ativa reversa',
  null,
  null,
  'Sinal/ruído PLC (gateway)',
  null,
  null,
  null,
  null,
  null,
  null,
  null,
];

// Decodifica uma word de 32 bits (alarme ou trip) na lista de descricoes
// dos bits ativos. Bits "nao utilizado" (null no mapa) sao ignorados.
export const decodeBitmask = (rawValue, bitMap) => {
  const n = Number(rawValue);
  if (!Number.isFinite(n) || n === 0) return [];
  // eslint-disable-next-line no-bitwise
  const value = n >>> 0;
  const active = [];
  for (let bit = 0; bit < 32; bit += 1) {
    // eslint-disable-next-line no-bitwise
    if ((value & (1 << bit)) !== 0) {
      const label = bitMap[bit];
      if (label) active.push(label);
    }
  }
  return active;
};

// Lista de alarmes/trips ATIVOS de uma thing bluebox, decodificados das
// words Alr1/Alr2/Trp1/Trp2. Trips vem prefixados pra diferenciar do alarme.
export const extractBlueboxAlarms = (data) => {
  if (!data || typeof data !== 'object') return [];
  return [
    ...decodeBitmask(data.Alr1, ALR1_TRP1_BITS),
    ...decodeBitmask(data.Alr2, ALR2_TRP2_BITS),
    ...decodeBitmask(data.Trp1, ALR1_TRP1_BITS).map((n) => `Trip: ${n}`),
    ...decodeBitmask(data.Trp2, ALR2_TRP2_BITS).map((n) => `Trip: ${n}`),
  ];
};
